import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import Cookie from 'js-cookie';
import { useTranslation } from 'react-i18next';
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
import './cookies.scss';

const Cookies = () => {
  const [isAccepted, setIsAccepted] = useState(null);
  var cookieAccepted = Cookie.get('cookieAccepted');
  const { t } = useTranslation(['footer']);
  const { assignedLibrary } = useAssignedLibrary();

  if (!cookieAccepted) {
    Cookie.set('cookieAccepted', 'false', { sameSite: 'strict' });
    cookieAccepted = Cookie.get('cookieAccepted');
  }

  useEffect(() => {
    setIsAccepted(cookieAccepted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAccepted]);

  const acceptCookie = () => {
    Cookie.set('cookieAccepted', 'true', { sameSite: 'strict' });
    cookieAccepted = Cookie.get('cookieAccepted');
    setIsAccepted(cookieAccepted);
  };

  return (
    <div>
      {isAccepted === 'false' ? (
        <Container fluid className="cookies">
          <Row className="cookies-row">
            <Col lg={8}>
              <p>{t('cookies')}</p>
            </Col>
            <Col lg={2}>
              <p className="mx-3" onClick={acceptCookie}>
                {t('aceptar')}
              </p>
              <a href={`/${assignedLibrary}/cookies`}>{t('leerMas')}</a>
            </Col>
          </Row>
        </Container>
      ) : null}
    </div>
  );
};

export default Cookies;
